// src/features/feeds/components/FeedsLayout.tsx

import { useEffect, useRef } from 'react';
import { Outlet, useRouterState } from '@tanstack/react-router';
import { SelectionProvider } from '@/shared/contexts/SelectionContext';
import { useFeedGridState } from '../stores/feedGridState';
import { markStart } from '@/shared/utils/perf';

/**
 * Layout route for /feeds.
 * SelectionProvider wraps both list and detail routes so selection persists.
 * Grid/search/sort/scroll state persistence is handled by Zustand store.
 */
export function FeedsLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const markBackNavStart = useFeedGridState((s) => s.markBackNavStart);
  const prevPathRef = useRef(pathname);

  useEffect(() => {
    const prevPath = prevPathRef.current;
    const movedFromDetailToList =
      /^\/feeds\/.+/.test(prevPath) &&
      (pathname === '/feeds' || pathname === '/feeds/');

    if (movedFromDetailToList) {
      markBackNavStart();
      markStart('feeds.grid.backnav.firstRowsPaint');
    }

    prevPathRef.current = pathname;
  }, [pathname, markBackNavStart]);

  return (
    <SelectionProvider>
      <Outlet />
    </SelectionProvider>
  );
}
